import type {Component} from "vue";
import {CalendarDays, ClipboardList, Mail, MessageSquareReply, MessageSquareText, Pill, ShoppingBag, UsersRound} from "@lucide/vue";
import {FollowUpEventKind} from "@/program/interfaces/ProgramFollowUp";

/**
 * The marker icon and colors of each event kind, shared by the timeline and its legend.
 */
export const FOLLOW_UP_EVENT_STYLES: Record<FollowUpEventKind, { icon: Component, classes: string }> = {
    interview: {icon: UsersRound, classes: 'bg-primary border-primary text-white'},
    survey: {icon: ClipboardList, classes: 'bg-apodisPink border-lightPurple-darkest text-darkPurple'},
    rcs: {icon: MessageSquareText, classes: 'bg-lightPurple-lightest border-primary text-primary'},
    rcs_reply: {icon: MessageSquareReply, classes: 'bg-secondary-lightest border-secondary-darkest text-secondary-darkest'},
    validating_sale: {icon: Pill, classes: 'bg-secondary border-secondary-darkest text-gray-dark'},
    targeting_sale: {icon: ShoppingBag, classes: 'bg-orange-light border-orange text-gray-dark'},
    appointment: {icon: CalendarDays, classes: 'bg-pink-lighter border-pink text-gray-dark'},
    mssante: {icon: Mail, classes: 'bg-white border-red-light text-red-light'},
};

/**
 * The marker classes of a planned event: dashed and hollow.
 */
export const FOLLOW_UP_PLANNED_CLASSES = 'bg-white border-dashed border-primary text-primary';
